let sliderProductInit = null;

/* Inicializar por defaul la primera categoria */
function initProductsSlider($slider, objConfig) {
  const sliderProductInitEl = `.${$slider}.init`;

  sliderProductInit = new Swiper(sliderProductInitEl, {
    ...objConfig,
    on: {
      beforeInit: function () {
        document.querySelector(sliderProductInitEl).classList.add("show");
      },
      beforeDestroy: function () {
        // console.log("destruyo init", sliderProductInitEl);
        document.querySelector(sliderProductInitEl).classList.remove("show");
      },
    },
  });

  return sliderProductInit;
}

/* Inicializar el slider dependiendo de la categoria a la que se le haga click */
function productsSlider($slider, objSlider, objConfig) {
  let swiperSlider;

  const categories = document.querySelectorAll(
    `.slider-products__categories.section-${$slider} li a`
  );

  categories.forEach((category) => {
    category.addEventListener("click", function (e) {
      e.preventDefault();

      categories.forEach((category) => category.classList.remove("active"));

      category.classList.add("active");

      let categorySelected = e.target.dataset.category;

      if (objSlider != null || objSlider != undefined)
        objSlider.destroy(true, true);

      if (swiperSlider != null || swiperSlider != undefined)
        swiperSlider.destroy(true, true);
      if (document.querySelector(`.${categorySelected}.${$slider}`) == null)
        return;

      //console.log(`.${categorySelected}.${$slider}`);
      swiperSlider = new Swiper(`.${categorySelected}.${$slider}`, {
        ...objConfig,
        on: {
          beforeInit: function () {
            document
              .querySelector(`.${categorySelected}.${$slider}`)
              .classList.add("show");
          },
          beforeDestroy: function () {
            // console.log(`.${categorySelected}.${$slider}`);
            document
              .querySelectorAll(`.${$slider}`)
              .forEach((featuredProduct) => {
                featuredProduct.classList.remove("show");
              });
          },
        },
      });
    });
  });
}

export { initProductsSlider, productsSlider };
